function animations() {
    // Checks is a elements bounding rectangle is in view
    let inViewPort = (boundingRect) => (
        boundingRect.top >= 0 &&
        (boundingRect.bottom - boundingRect.height) <= (window.innerHeight || document.documentElement.clientHeight)
    );

    let animationsPlayed

    if (sessionStorage.hasOwnProperty("playedAnimations"))
        animationsPlayed = JSON.parse(sessionStorage.getItem("playedAnimations"));

    animationsPlayed = animationsPlayed ?? [];

    // For each animation retrieve it and play the animation if it is in view then add it to session storage to it
    // cannot be played again until the session is refreshed
    Array.from(document.getElementsByClassName("animation")).forEach((animation, i) => {
        // Skip if the animation isn't in the view port or the animation has already been played this session
        if (inViewPort(animation.getBoundingClientRect()) && !animationsPlayed.includes(i)) {
            animation.classList.add("animation--show");
            animationsPlayed.push(i);
        }
    });

    // Update played animations
    sessionStorage.setItem("playedAnimations", JSON.stringify(animationsPlayed));
}

window.addEventListener("load", animations);
window.addEventListener("scroll", animations);
